import { SContainer } from "./Start.styled";
import { ReactComponent as StarSvg } from "./image/start.svg";

interface StarProps {
	padding0?: boolean;
}

export const Star = ({ padding0 = false }: StarProps) => {
	return (
		<SContainer $padding0={padding0}>
			<StarSvg />
		</SContainer>
	);
};
